module.exports = __webpack_public_path__ + "img/colorado_route.887885ca.jpg";